import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const eocOverviewRoute: InvariantJiraRoute = {
	name: 'eoc-overview',
	path: '/jira/ops/overview',
	exact: true,
};
